<template>
    <tr v-if="space_before_row">
        <td colspan="3" style="width: 500px">&nbsp;</td>
    </tr>
    <tr v-else :class="{ className }">
        <td
            :class="tooltip ? 'pointer' : ''"
            :title="tooltip"
            :rowSpan="rowSpan"
            v-if="!hideTitle"
            style="width: 500px"
        >
            <span :class="title_class_name"
                >{{ title
                }}<i
                    v-if="tooltip"
                    class="fa fa-fw fa-info-circle text-primary"
                ></i
            ></span>
        </td>
        <td>
            <b>{{ value }}</b>
        </td>

        <td>
            <p class="note-text">{{note}}</p>
            <phieu-luong-detail-item
                v-if="checkShowDetail()"
                :details="details"
                :category="category"
                :payslipType="payslipType"
            >
            </phieu-luong-detail-item>
            <LinkInstruct v-if="isHeadOffice" :linkManage="linkManage" :link="linkManage ? link : linkSale"></LinkInstruct>
            <trai-phieu-detail-item
                v-if="[THUONG_TRAI_PHIEU_TICH_LUY, GIA_TRI_TRAI_PHIEU_TICH_LUY].includes(category)"
            ></trai-phieu-detail-item>
            <el-button type="text" v-if="CHI_VAN_PHONG == category" @click="transferLink">Xem Chi tiết</el-button>
        </td>
    </tr>
</template>

<script>
import PhieuLuongDetailItem from "./phieu-luong-detail-item";
import LinkInstruct from "./Details/LinkInstruct";
import {
    CATEGORY_DOANH_SO_DOI,
    CATEGORY_TONG_DOANH_SO,
    CATEGORY_DOANH_SO_DOI_VP,
    CATEGORY_THU_NHAP_RSM,
    CATEGORY_PHAT,
    CATEGORY_PHU_CAP_KHAC,
    CATEGORY_PHU_CAP_MIEN_THUE,
    CATEGORY_TRU_KHAC,
    CATEGORY_TANG_CA,
    CATEGORY_THUE_TNCN,
    THUONG_TRAI_PHIEU_TICH_LUY, GIA_TRI_TRAI_PHIEU_TICH_LUY,
    CATEGORY_THUONG,
    CATEGORY_TAM_UNG,
    CHI_VAN_PHONG
} from "../../../core/config/payslipConfig";
import TraiPhieuDetailItem from "./trai-phieu-detail-item.vue";
import { GET_DETAIL_BOND_VALUE } from "../../../core/services/store/service.module";

export default {
    name: "phieu-luong-item",
    components: { TraiPhieuDetailItem, PhieuLuongDetailItem, LinkInstruct },
    props: {
        payslipType: {
            type: String,
            default: null,
        },
        details: {
            type: Array,
            default: () => {
                return [];
            },
        },
        category: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            default: null,
        },
        className: {
            type: String,
            default: null,
        },
        to: {
            type: String,
            default: null,
        },
        tooltip: {
            type: String,
            default: null,
        },
        value: {
            type: [String, Number],
            default: null,
        },
        hideTitle: {
            type: Boolean,
            default: false,
        },
        title_class_name: {
            type: String,
            default: "",
        },
        space_before_row: {
            type: Boolean,
            default: false,
        },
        linkManage: {
            type: Boolean,
            default: false,
        },
        rowSpan: {
            type: Number,
        },
        note: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            CATEGORY_THU_NHAP_RSM: CATEGORY_THU_NHAP_RSM,
            CATEGORY_DOANH_SO_DOI_VP: CATEGORY_DOANH_SO_DOI_VP,
            CATEGORY_DOANH_SO_DOI: CATEGORY_DOANH_SO_DOI,
            CATEGORY_TONG_DOANH_SO: CATEGORY_TONG_DOANH_SO,
            CATEGORY_PHAT: CATEGORY_PHAT,
            CATEGORY_PHU_CAP_MIEN_THUE: CATEGORY_PHU_CAP_MIEN_THUE,
            CATEGORY_PHU_CAP_KHAC: CATEGORY_PHU_CAP_KHAC,
            CATEGORY_TRU_KHAC: CATEGORY_TRU_KHAC,
            CATEGORY_TANG_CA: CATEGORY_TANG_CA,
            CATEGORY_THUONG: CATEGORY_THUONG,
            CATEGORY_TAM_UNG: CATEGORY_TAM_UNG,
            THUONG_TRAI_PHIEU_TICH_LUY: THUONG_TRAI_PHIEU_TICH_LUY,
            GIA_TRI_TRAI_PHIEU_TICH_LUY: GIA_TRI_TRAI_PHIEU_TICH_LUY,
            haveDataBond: false,
            CATEGORY_THUE_TNCN: CATEGORY_THUE_TNCN,
            CHI_VAN_PHONG: CHI_VAN_PHONG,
            link: "https://docs.google.com/spreadsheets/d/1daS3r2QqaXSViPGAIPP0_JMVH4JKIY6RmZTKJH01__Y/edit?gid=0#gid=0",
            linkSale: "https://docs.google.com/spreadsheets/d/1W9AEmiROXlo9VO_-TfsC1Y4ySGNsTQla9T7O8730IKA/edit?gid=0#gid=0 ",
        };
    },
    methods: {
        checkShowDetail() {
            if (this.details == null || this.details.length == 0) {
                return false;
            }
            // if (this.payslipType === "head_office") {
            //    return [CATEGORY_THUE_TNCN].includes(this.category);
            // }

            return [
                CATEGORY_THU_NHAP_RSM,
                CATEGORY_PHAT,
                CATEGORY_PHU_CAP_MIEN_THUE,
                CATEGORY_PHU_CAP_KHAC,
                CATEGORY_TANG_CA,
                CATEGORY_TRU_KHAC,
                CATEGORY_THUONG,
                CATEGORY_TAM_UNG,
            ].includes(this.category);
        },
        checkDataBonds() {
            this.$store
                .dispatch(GET_DETAIL_BOND_VALUE)
                .then((data) => {
                    this.haveDataBond = data?.data?.length !== 0;
                })
                .catch(() => {
                    this.haveDataBond = false;
                });
        },
        transferLink() {
            const routeData = this.$router.resolve({
                name: 'bao-cao-van-phong',
                query: {
                    date: this.$route.query.year
                        ? `${this.$route.query.year}-${this.$route.query.month}`
                        : '',
                },
            });

            window.open(routeData.href, '_blank');
        },
    },
    mounted() {
        if (this.category === THUONG_TRAI_PHIEU_TICH_LUY) {
            this.checkDataBonds();
        }
    },
    computed: {
        isHeadOffice() {
            return (
                [
                    "head_office",
                    "sale_leader_province",
                    "sale_leader_center",
                    "sale_luong_cung_v3",
                    "sale_luong_mem_v3",
                    "gdkv",
                    "gdvp"
                ].includes(this.payslipType) &&
                this.category === CATEGORY_THUE_TNCN
            );
        },
    },
};
</script>
<style>
.pointer {
    cursor: pointer;
}
.note-text {
    white-space: pre-line;
}
</style>
